import React from 'react';
import clsx from 'clsx';
import { deburr } from 'lodash';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';

import { getPredictPredictionsPageUrl, ROUTES } from '@futrli/shared-services';

import { BalanceSheetFR } from '../balance-sheet/balance-sheet-fr';
import { ConsolidatedForecastReportStructureWithTabs } from '../../../../core/types';
import { ProfitAndLossFR } from '../profit-and-loss/profit-and-loss-fr';
import { PredictionsSubTabFR } from '../predictions-sub-tab/predictions-sub-tab-fr';
import { usePredictionsInfoContext } from '../../context/predictions-info-context';

import styles from './predictions-nav-data-controls.scss';

const PREDICTIONS_SUB_PAGES = [
  {
    route: ROUTES.PROFIT_AND_LOSS,
    routeComponent: ProfitAndLossFR
  },
  {
    route: ROUTES.BALANCE_SHEET,
    routeComponent: BalanceSheetFR
  }
];

export const PredictionsRouterFR = () => {
  const { workspaceId, organisationId, forecastId } = useParams();
  const { forecastReportV2: forecastReport } = usePredictionsInfoContext();
  const subtabs = (forecastReport?.structure as ConsolidatedForecastReportStructureWithTabs).tabs || [];

  return (
    <div className={clsx(styles.content, styles.pageWidthWrapper)}>
      <Routes>
        {PREDICTIONS_SUB_PAGES.map(({ route, routeComponent: RouteComponent }) => (
          <Route key={route} path={route} element={<RouteComponent />} />
        ))}
        {subtabs.map(tab => {
          const route = encodeURI(deburr(tab.id || tab.label).replace(/ /g, '_'));
          return <Route key={`${route}-route`} path={route} element={<PredictionsSubTabFR tab={tab} />} />;
        })}
        <Route
          path="*"
          element={
            <Navigate
              to={`${getPredictPredictionsPageUrl(workspaceId!, organisationId!, forecastId!)}${
                ROUTES.PROFIT_AND_LOSS
              }`}
            />
          }
        />
      </Routes>
    </div>
  );
};
